import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["size", "color", "alignWithText", "aria-label", "id"];
// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.

import { useTheme } from 'foundations-theming/utils';
import { useIconSize } from '../useIconSize';
import { StyledIcon } from '../StyledIcon';
import { getDataProps } from '../getDataProps';
import { jsx as _jsx } from "react/jsx-runtime";
export const LinkIcon = _ref => {
  let {
      size: sizeProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      color: colorProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      alignWithText = false,
      'aria-label': ariaLabel,
      id
    } = _ref,
    restProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const theme = useTheme();
  const dataProps = getDataProps(restProps);

  // Setting default values here
  const size = sizeProp !== null && sizeProp !== void 0 ? sizeProp : 'inherit';
  const color = colorProp !== null && colorProp !== void 0 ? colorProp : 'inherit';
  const sizeValue = useIconSize(size);
  const sizeCSSValue = sizeProp ? `${sizeValue} !important` : sizeValue; // Adds the `!important` flag to the `size` value if one is provided via props

  const colorValue = color === 'inherit' ? 'currentColor' : theme.color[color]; // inherit = currentColor = text color of the parent element
  const colorCSSValue = colorProp ? `${colorValue} !important` : colorValue; // Adds the `!important` flag to the `color` value if one is provided via props

  return /*#__PURE__*/_jsx(StyledIcon, Object.assign({}, dataProps, {
    $size: sizeCSSValue,
    $color: colorCSSValue,
    $alignWithText: alignWithText,
    "aria-label": ariaLabel,
    "aria-hidden": ariaLabel === undefined ? true : undefined,
    id: id,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    focusable: "false",
    "data-icon-name": "Link",
    children: /*#__PURE__*/_jsx("path", {
      d: "M23 19.79c0-.97-.78-1.75-1.75-1.75s-1.75.78-1.75 1.75v6.57c0 .08-.07.15-.15.15h-6.7c-.08 0-.15-.07-.15-.15v-6.57c0-.97-.78-1.75-1.75-1.75S9 18.82 9 19.79v6.57c0 2.02 1.63 3.65 3.65 3.65h6.7c2.02 0 3.65-1.63 3.65-3.65zm0-14.14C23 3.63 21.37 2 19.35 2h-6.7C10.63 2 9 3.63 9 5.65v6.57c0 .97.78 1.75 1.75 1.75s1.75-.78 1.75-1.75V5.65c0-.08.07-.15.15-.15h6.7c.08 0 .15.07.15.15v6.57c0 .97.78 1.75 1.75 1.75S23 13.19 23 12.22zm-5.25 16.04V10.32c0-.97-.78-1.75-1.75-1.75s-1.75.78-1.75 1.75v11.37c0 .97.78 1.75 1.75 1.75s1.75-.78 1.75-1.75"
    })
  }));
};